import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Footer from '../components/Footer';

const Health = () => {
  return (
    <>
      <nav aria-label="breadcrumb" className="mt-5 d-flex justify-content-center">
        <ol className="breadcrumb mb-0">
          <li className="breadcrumb-item">
            <a href="/">Home</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            Health Insurance
          </li>
        </ol>
      </nav><br />

      {/* Hero Section */}
      <div className="container my-4">
        <div className="row align-items-center g-4">
          <div className="col-lg-6">
            <h1 className="display-5 fw-bold text-primary mb-3">
              Become a Health Insurance Agent
            </h1>
            <p className="lead text-muted mb-4">
              Join India's fastest-growing health insurance distribution network
            </p>
            <div className="mb-4">
              <span className="badge bg-primary bg-opacity-10 text-primary px-3 py-2 rounded-pill me-2">
                🚀 ₹30,000+ Crore Market
              </span>
              <span className="badge bg-success bg-opacity-10 text-success px-3 py-2 rounded-pill">
                💰 High Demand Product
              </span>
            </div>
            <p className="mb-3" style={{ textAlign: 'justify', lineHeight: '1.8' }}>
              At <strong>Agency Bazaar</strong>, we connect aspiring insurance professionals with 
              India's leading health insurance companies. A <strong>Health Insurance Agent</strong> 
              specializes in medical insurance products, helping individuals and families protect 
              themselves against rising healthcare costs and medical emergencies.
            </p>
          </div>
          <div className="col-lg-6">
            <div className="bg-light rounded-4 p-4 text-center shadow-sm">
              <div className="display-1 mb-3">🏥</div>
              <h4 className="text-primary">Join as a Health Insurance Agent</h4>
              <p className="text-muted">Build a rewarding career helping people stay protected</p>
            </div>
          </div>
        </div>
      </div>

      {/* What is a Health Insurance Agent Section */}
      <div className="container my-5">
        <div className="text-center mb-4">
          <h2 className="fw-bold text-primary">What is a <span className="text-dark">Health Insurance Agent?</span></h2>
          <div className="d-flex justify-content-center">
            <div style={{
              width: '60px',
              height: '3px',
              backgroundColor: '#0d6efd',
              borderRadius: '2px'
            }}></div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-10 mx-auto">
            <div className="p-4 shadow-sm rounded-4 bg-white">
              <p className="mb-3" style={{ fontSize: '1.05rem', lineHeight: '1.8' }}>
                A <strong>Health Insurance Agent</strong> is an <strong>IRDAI-licensed professional</strong> who specializes in 
                health and medical insurance products. With healthcare costs rising 10-15% annually, 
                health insurance has become a necessity for every Indian family. Their primary role includes:
              </p>
              <ul style={{ fontSize: '1rem', lineHeight: '1.8' }}>
                <li>🏥 <strong>Medical Insurance</strong> - Hospitalization, daycare procedures, OPD coverage</li>
                <li>👨‍👩‍👧‍👦 <strong>Family Floater Plans</strong> - Cover entire family under single sum insured</li>
                <li>👴 <strong>Senior Citizen Plans</strong> - Specialized coverage for parents above 60 years</li>
                <li>🦷 <strong>Critical Illness Plans</strong> - Lump sum payment on diagnosis of major diseases</li>
                <li>👶 <strong>Maternity Plans</strong> - Coverage for pregnancy, delivery, and newborn care</li>
                <li>💼 <strong>Group Health Plans</strong> - Corporate coverage for businesses and employees</li>
              </ul>
              <div className="alert alert-primary mt-3">
                <strong>📊 Market Opportunity:</strong> India's health insurance market is growing at <strong>25-30% annually</strong> post-COVID. Only <strong>35% of Indians</strong> have health insurance coverage, leaving <strong>65% unprotected</strong> - a massive opportunity for agents!
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Benefits of Joining as Health Insurance Agent */}
      <div className="container my-5">
        <div className="text-center mb-4">
          <h2 className="fw-bold text-primary">Benefits of Joining as <span className="text-dark">Health Insurance Agent</span></h2>
          <div className="d-flex justify-content-center">
            <div style={{
              width: '60px',
              height: '3px',
              backgroundColor: '#0d6efd',
              borderRadius: '2px'
            }}></div>
          </div>
          <p className="text-muted mt-3">Why health insurance is the fastest-growing career in insurance</p>
        </div>

        <div className="row g-4">
          <div className="col-md-6 col-lg-4">
            <div className="p-4 shadow-sm rounded-4 h-100 bg-white"
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
                }}
                style={{ transition: 'all 0.3s ease' }}>
              <div className="fs-1 mb-3">💰</div>
              <h5 className="fw-bold">Attractive Commissions</h5>
              <p className="text-muted">Earn 10-25% commission on health policies + renewal commissions every year.</p>
              <small className="text-primary">High demand = Easy selling</small>
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <div className="p-4 shadow-sm rounded-4 h-100 bg-white"
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
                }}
                style={{ transition: 'all 0.3s ease' }}>
              <div className="fs-1 mb-3">🔄</div>
              <h5 className="fw-bold">100% Renewal Income</h5>
              <p className="text-muted">Health policies renew EVERY YEAR. Build a client base and earn recurring commissions annually without extra effort!</p>
              <small className="text-primary">Passive income grows yearly</small>
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <div className="p-4 shadow-sm rounded-4 h-100 bg-white"
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
                }}
                style={{ transition: 'all 0.3s ease' }}>
              <div className="fs-1 mb-3">📈</div>
              <h5 className="fw-bold">Explosive Market Growth</h5>
              <p className="text-muted">Post-COVID awareness has skyrocketed. 25-30% annual industry growth creates unlimited opportunities.</p>
              <small className="text-primary">Everyone needs health insurance</small>
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <div className="p-4 shadow-sm rounded-4 h-100 bg-white"
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
                }}
                style={{ transition: 'all 0.3s ease' }}>
              <div className="fs-1 mb-3">📚</div>
              <h5 className="fw-bold">Free Training & Certification</h5>
              <p className="text-muted">IRDAI-approved training, licensing support, and continuous learning at no cost.</p>
              <small className="text-primary">Become certified quickly</small>
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <div className="p-4 shadow-sm rounded-4 h-100 bg-white"
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
                }}
                style={{ transition: 'all 0.3s ease' }}>
              <div className="fs-1 mb-3">⏰</div>
              <h5 className="fw-bold">Flexible Working Hours</h5>
              <p className="text-muted">Work part-time or full-time. Perfect for students, homemakers, and retired professionals.</p>
              <small className="text-primary">Be your own boss</small>
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <div className="p-4 shadow-sm rounded-4 h-100 bg-white"
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
                }}
                style={{ transition: 'all 0.3s ease' }}>
              <div className="fs-1 mb-3">🏆</div>
              <h5 className="fw-bold">Incentives & Rewards</h5>
              <p className="text-muted">Foreign trips, bonuses, awards, and career growth opportunities from top insurers.</p>
              <small className="text-primary">Performance-based recognition</small>
            </div>
          </div>
        </div>
      </div>

      {/* How to Work as Health Insurance Agent */}
      <div className="container my-5">
        <div className="text-center mb-4">
          <h2 className="fw-bold text-primary">How to Work as <span className="text-dark">Health Insurance Agent</span></h2>
          <div className="d-flex justify-content-center">
            <div style={{
              width: '60px',
              height: '3px',
              backgroundColor: '#0d6efd',
              borderRadius: '2px'
            }}></div>
          </div>
          <p className="text-muted mt-3">Simple steps to start your health insurance career</p>
        </div>

        <div className="row g-4">
          <div className="col-md-6 col-lg-4">
            <div className="p-4 shadow-sm rounded-4 h-100 bg-white text-center">
              <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3" 
                   style={{ width: '60px', height: '60px', fontSize: '24px', fontWeight: 'bold' }}>
                1
              </div>
              <h5 className="fw-bold">Complete IRDAI Training</h5>
              <p className="text-muted">Enroll in 50-hour compulsory training from an IRDAI-approved institute (online/offline).</p>
              <small className="text-primary">Duration: 2-3 weeks</small>
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <div className="p-4 shadow-sm rounded-4 h-100 bg-white text-center">
              <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3" 
                   style={{ width: '60px', height: '60px', fontSize: '24px', fontWeight: 'bold' }}>
                2
              </div>
              <h5 className="fw-bold">Pass IC-38 Exam</h5>
              <p className="text-muted">Clear IRDAI's IC-38 examination to get your health insurance agent license.</p>
              <small className="text-primary">Exam conducted online</small>
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <div className="p-4 shadow-sm rounded-4 h-100 bg-white text-center">
              <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3" 
                   style={{ width: '60px', height: '60px', fontSize: '24px', fontWeight: 'bold' }}>
                3
              </div>
              <h5 className="fw-bold">Get Appointed with Insurers</h5>
              <p className="text-muted">Agency Bazaar connects you with India's top health insurance companies.</p>
              <small className="text-primary">Work with multiple insurers</small>
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <div className="p-4 shadow-sm rounded-4 h-100 bg-white text-center">
              <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3" 
                   style={{ width: '60px', height: '60px', fontSize: '24px', fontWeight: 'bold' }}>
                4
              </div>
              <h5 className="fw-bold">Target the Right Audience</h5>
              <p className="text-muted">Focus on families, senior citizens, young professionals, and corporate employees.</p>
              <small className="text-primary">Everyone needs health cover</small>
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <div className="p-4 shadow-sm rounded-4 h-100 bg-white text-center">
              <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3" 
                   style={{ width: '60px', height: '60px', fontSize: '24px', fontWeight: 'bold' }}>
                5
              </div>
              <h5 className="fw-bold">Sell & Earn Commissions</h5>
              <p className="text-muted">Earn upfront commissions + annual renewals. Higher sum insured = higher earnings.</p>
              <small className="text-primary">10-25% commission rates</small>
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <div className="p-4 shadow-sm rounded-4 h-100 bg-white text-center">
              <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3" 
                   style={{ width: '60px', height: '60px', fontSize: '24px', fontWeight: 'bold' }}>
                💡
              </div>
              <h5 className="fw-bold">Daily Work Activities</h5>
              <p className="text-muted">• Client meetings (10-15 daily)<br/>• Explaining coverage & benefits<br/>• Renewal follow-ups<br/>• Claim assistance & support</p>
              <small className="text-primary">Help when needed most</small>
            </div>
          </div>
        </div>
      </div>

      {/* Types of Health Insurance Plans Agents Sell */}
      <div className="container my-5">
        <div className="text-center mb-4">
          <h2 className="fw-bold text-primary">Health Insurance Plans <span className="text-dark">You'll Sell as an Agent</span></h2>
          <div className="d-flex justify-content-center">
            <div style={{
              width: '60px',
              height: '3px',
              backgroundColor: '#0d6efd',
              borderRadius: '2px'
            }}></div>
          </div>
          <p className="text-muted mt-3">Diverse products with massive demand across India</p>
        </div>

        <div className="row g-4">
          <div className="col-md-6 col-lg-4">
            <div className="card border-0 shadow-sm h-100 text-center"
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 10px 25px rgba(0,0,0,0.12)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
                }}
                style={{ transition: 'all 0.3s ease' }}>
              <div className="card-body">
                <div className="fs-1 mb-2">👨‍👩‍👧‍👦</div>
                <h5 className="card-title fw-bold">Family Floater Plan</h5>
                <p className="card-text text-muted small">Cover entire family (self + spouse + kids) under single sum insured of ₹5-25 Lakhs.</p>
                <small className="text-primary">Best-selling product | High demand</small>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <div className="card border-0 shadow-sm h-100 text-center"
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 10px 25px rgba(0,0,0,0.12)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
                }}
                style={{ transition: 'all 0.3s ease' }}>
              <div className="card-body">
                <div className="fs-1 mb-2">👴</div>
                <h5 className="card-title fw-bold">Senior Citizen Plan</h5>
                <p className="card-text text-muted small">Specialized coverage for parents (60+ years) with lower waiting periods and higher sum insured.</p>
                <small className="text-primary">Growing segment | Good commissions</small>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <div className="card border-0 shadow-sm h-100 text-center"
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 10px 25px rgba(0,0,0,0.12)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
                }}
                style={{ transition: 'all 0.3s ease' }}>
              <div className="card-body">
                <div className="fs-1 mb-2">🦷</div>
                <h5 className="card-title fw-bold">Critical Illness Plan</h5>
                <p className="card-text text-muted small">Lump sum payment on diagnosis of cancer, heart attack, kidney failure, etc.</p>
                <small className="text-primary">High value | Easy to sell</small>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <div className="card border-0 shadow-sm h-100 text-center"
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 10px 25px rgba(0,0,0,0.12)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
                }}
                style={{ transition: 'all 0.3s ease' }}>
              <div className="card-body">
                <div className="fs-1 mb-2">💊</div>
                <h5 className="card-title fw-bold">Individual Health Plan</h5>
                <p className="card-text text-muted small">Personalized coverage for single individuals with sum insured options from ₹3-50 Lakhs.</p>
                <small className="text-primary">For young professionals</small>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <div className="card border-0 shadow-sm h-100 text-center"
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 10px 25px rgba(0,0,0,0.12)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
                }}
                style={{ transition: 'all 0.3s ease' }}>
              <div className="card-body">
                <div className="fs-1 mb-2">👩‍⚕️</div>
                <h5 className="card-title fw-bold">Maternity Plan</h5>
                <p className="card-text text-muted small">Coverage for pregnancy, delivery, pre/post-natal expenses, and newborn baby coverage.</p>
                <small className="text-primary">High emotional connect</small>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <div className="card border-0 shadow-sm h-100 text-center"
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 10px 25px rgba(0,0,0,0.12)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
                }}
                style={{ transition: 'all 0.3s ease' }}>
              <div className="card-body">
                <div className="fs-1 mb-2">💼</div>
                <h5 className="card-title fw-bold">Group Health Plan</h5>
                <p className="card-text text-muted small">Corporate coverage for businesses, SMEs, startups covering employees and their families.</p>
                <small className="text-primary">Bulk business | High premiums</small>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Why Health Insurance is a Great Career */}
      <div className="container my-5">
        <div className="bg-light rounded-4 p-5">
          <div className="text-center mb-4">
            <h2 className="fw-bold text-primary">Why Health Insurance is a <span className="text-dark">Smart Career Choice</span></h2>
            <div className="d-flex justify-content-center">
              <div style={{
                width: '60px',
                height: '3px',
                backgroundColor: '#0d6efd',
                borderRadius: '2px'
              }}></div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-3 mb-3">
              <div className="text-center p-3">
                <div className="fs-2 mb-2">📈</div>
                <h6 className="fw-bold">25-30% Growth</h6>
                <p className="small text-muted">Fastest growing insurance segment</p>
              </div>
            </div>
            <div className="col-md-3 mb-3">
              <div className="text-center p-3">
                <div className="fs-2 mb-2">🏥</div>
                <h6 className="fw-bold">7000+ Hospitals</h6>
                <p className="small text-muted">Cashless treatment network</p>
              </div>
            </div>
            <div className="col-md-3 mb-3">
              <div className="text-center p-3">
                <div className="fs-2 mb-2">🔄</div>
                <h6 className="fw-bold">100% Renewals</h6>
                <p className="small text-muted">Annual recurring income</p>
              </div>
            </div>
            <div className="col-md-3 mb-3">
              <div className="text-center p-3">
                <div className="fs-2 mb-2">💰</div>
                <h6 className="fw-bold">Tax Benefits</h6>
                <p className="small text-muted">Up to ₹75,000 deduction under 80D</p>
              </div>
            </div>
          </div>
          <div className="alert alert-success mt-3">
            <strong>💡 Key Insight:</strong> Health insurance is now a NECESSITY, not a luxury. With healthcare inflation at 10-15% annually and COVID-19 creating massive awareness, every Indian family needs health coverage. This creates unlimited earning potential for health insurance agents!
          </div>
        </div>
      </div>

      {/* Healthcare Statistics - The Opportunity */}
      <div className="container my-5">
        <div className="row g-4">
          <div className="col-md-6">
            <div className="card border-0 shadow-sm h-100">
              <div className="card-body p-4">
                <h4 className="fw-bold text-primary mb-3">📊 India's Healthcare Reality</h4>
                <ul className="list-unstyled">
                  <li className="mb-3">
                    <strong>⚠️ 65% Indians</strong>
                    <p className="text-muted small mb-0">have NO health insurance coverage</p>
                  </li>
                  <li className="mb-3">
                    <strong>💰 ₹50,000 - ₹2,00,000</strong>
                    <p className="text-muted small mb-0">Average hospitalization cost per illness</p>
                  </li>
                  <li className="mb-3">
                    <strong>📈 10-15% Annual</strong>
                    <p className="text-muted small mb-0">Healthcare inflation in India</p>
                  </li>
                  <li className="mb-3">
                    <strong>🆘 55 Million People</strong>
                    <p className="text-muted small mb-0">fall below poverty line due to medical expenses</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="card border-0 shadow-sm h-100">
              <div className="card-body p-4">
                <h4 className="fw-bold text-primary mb-3">🎯 Your Opportunity as an Agent</h4>
                <ul className="list-unstyled">
                  <li className="mb-3">
                    <strong>✅ 100 Crore+ Uninsured</strong>
                    <p className="text-muted small mb-0">Potential customers waiting for you</p>
                  </li>
                  <li className="mb-3">
                    <strong>✅ Corporate Mandates</strong>
                    <p className="text-muted small mb-0">Companies required to provide health cover</p>
                  </li>
                  <li className="mb-3">
                    <strong>✅ Government Schemes</strong>
                    <p className="text-muted small mb-0">Ayushman Bharat, PMJAY creating awareness</p>
                  </li>
                  <li className="mb-3">
                    <strong>✅ Digital Adoption</strong>
                    <p className="text-muted small mb-0">Easy online policy issuance and claims</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Skills Required for Success */}
      <div className="container my-5">
        <div className="card border-0 shadow-sm rounded-4 bg-white">
          <div className="card-body p-4">
            <h3 className="fw-bold text-primary mb-4 text-center">Skills Required to Succeed</h3>
            <div className="row">
              <div className="col-md-6">
                <ul className="list-unstyled">
                  <li className="mb-3">✅ <strong>Empathy & Patience</strong> - Understand health concerns genuinely</li>
                  <li className="mb-3">✅ <strong>Product Knowledge</strong> - Understand coverage, exclusions, waiting periods</li>
                  <li className="mb-3">✅ <strong>Communication Skills</strong> - Explain complex medical terms simply</li>
                  <li className="mb-3">✅ <strong>Networking Ability</strong> - Connect with doctors, hospitals, corporate HRs</li>
                </ul>
              </div>
              <div className="col-md-6">
                <ul className="list-unstyled">
                  <li className="mb-3">✅ <strong>Trust Building</strong> - Clients share sensitive health information</li>
                  <li className="mb-3">✅ <strong>Perseverance</strong> - Follow-ups lead to sales and renewals</li>
                  <li className="mb-3">✅ <strong>Digital Literacy</strong> - Use apps, online portals for quick issuance</li>
                  <li className="mb-3">✅ <strong>Claim Assistance</strong> - Guide clients during medical emergencies</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="container my-5">
        <div className="bg-primary text-white rounded-4 p-5 text-center"
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.02)';
              e.currentTarget.style.transition = 'all 0.3s ease';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
            }}>
          <h2 className="fw-bold mb-3">Ready to Start Your Career as Health Insurance Agent?</h2>
          <p className="mb-4">Join Agency Bazaar today! Get free training, licensing support, and appointment with top health insurers.</p>
          <button
            className="btn btn-light btn-lg px-5 rounded-pill text-primary fw-bold"
            style={{ transition: 'all 0.3s ease' }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.05)';
              e.currentTarget.style.backgroundColor = '#f8f9fa';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
            }}
          >
            Register as Health Insurance Agent Now →
          </button>
          <p className="mt-3 small opacity-75">Help Indians get the health coverage they need!</p>
        </div>
      </div>

      <Footer />
    </>
  )
}

export default Health;


